import { render, staticRenderFns } from "./DataInputDatetime.vue?vue&type=template&id=724f04c1&scoped=true&"
import script from "./DataInputDatetime.vue?vue&type=script&lang=js&"
export * from "./DataInputDatetime.vue?vue&type=script&lang=js&"
import style0 from "./DataInputDatetime.vue?vue&type=style&index=0&id=724f04c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f04c1",
  null
  
)

export default component.exports